module.exports = __webpack_public_path__ + "static/media/shopping-bag.bb04758f.svg";